module.exports = __webpack_public_path__ + "static/media/mental-green.15ae493f.svg";